import { WbTextField } from '@agilelab/plugin-wb-platform';
import { generateComponentIdentifier } from '@agilelab/plugin-wb-platform-common';
import { useEffect } from 'react';
import { useFormExtraConfigContext } from '../../../contexts/FormExtraConfigContext';
import { extractCustomProperties, isHidden } from '../../utils';
import { ComponentIdentifierPickerProps } from './schema';

export const ComponentIdentifierPicker = ({
  schema: {
    title = 'Identifier',
    description = 'Unique identifier of the component',
  },
  uiSchema,
  formContext,
  formData,
  onChange,
  placeholder,
  idSchema,
  required,
  rawErrors,
}: ComponentIdentifierPickerProps) => {
  useEffect(() => {
    onChange(
      generateComponentIdentifier(
        formContext.name,
        formContext.parentRef ?? formContext.dataproduct,
      ) ?? '',
    );
  }, [
    formContext.dataproduct,
    formContext.name,
    formContext.parentRef,
    onChange,
  ]);
  const autoFocus = uiSchema['ui:autofocus'];
  const customProps = extractCustomProperties(uiSchema);

  const { debounceMs } = useFormExtraConfigContext();

  return (
    <WbTextField
      id={idSchema?.$id}
      style={{ display: isHidden(uiSchema) ? 'none' : undefined }}
      label={title}
      disabled={!(uiSchema['ui:options']?.allowArbitraryValues ?? true)}
      placeholder={placeholder}
      helperText={description}
      required={required}
      value={formData ?? ''}
      debounceMs={debounceMs}
      onChange={({ target: { value } }) => onChange(value)}
      error={rawErrors?.length > 0 && !formData}
      inputProps={{ autoFocus }}
      {...customProps}
    />
  );
};
